import { convertToObject } from "../util";
export class PyStateWrapper {
    get(key) {
        if (!this.currentState) {
            throw new Error("Couldn't get");
        }
        return JSON.stringify(this.currentState.get(key));
    }
    set(key, value) {
        if (!this.currentState) {
            throw new Error("Couldn't set");
        }
        this.currentState.set(key, convertToObject(value));
    }
    add_message(to, type, data) {
        if (!this.currentState) {
            throw new Error("Couldn't set");
        }
        this.currentState.addMessage(to, type, convertToObject(data));
    }
    behavior_index() {
        if (!this.currentState) {
            throw new Error("Couldn't set");
        }
        return this.currentState.behaviorIndex();
    }
}
export class PyContextWrapper {
    neighbors() {
        return this.context?.neighbors().map((neighbor) => neighbor.agent_id);
    }
    getNeighbors(ids) {
        if (ids === undefined || ids[0] === undefined) {
            return [];
        }
        const ret = this.context
            ?.neighbors()
            .filter((neighbor) => neighbor.agent_id && ids.includes(neighbor.agent_id))
            .map((n) => JSON.stringify(n));
        return ret;
    }
    getNeighborKey(id, key) {
        const neighbors = this.context?.neighbors();
        return JSON.stringify(neighbors?.find((neighbor) => neighbor.agent_id === id)?.[key]);
    }
    messages() {
        return this.context?.messages();
    }
    step() {
        return this.context?.step();
    }
}
//# sourceMappingURL=wrappers.js.map